import { styled, Typography } from '@mui/material';

export const FieldLabelStyled = styled(Typography, {
  shouldForwardProp: (props) => props !== 'bold' && props !== 'fontSize',
})(({ bold, fontSize }) => ({
  fontSize: fontSize === 'medium' ? '1rem' : '1.5rem',
  fontWeight: bold ? 600 : 400,
}));
